import './MessageBox.css';
import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import Spinner from '../Spinner/Spinner';

import Cookie from 'js-cookie';

class InfoMsgBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: JSON.parse(props.message),
      onClose: props.onClose,
      loading: false,
    };
  }

  fileDownload = (documentPath) => {
    this.props.loading(documentPath);
    // this.setState({
    //   loading: true,
    // });

    // setTimeout(() => {
    //   this.setState({
    //     loading: false,
    //   });
    // }, 8000);
  };

  componentDidMount() {
    const script = document.createElement('script');

    script.src = 'js/modal.js';
    script.async = true;

    document.body.appendChild(script);

    //(JSON.stringify(this.state.message.popUpData));
  }

  render() {
    return (
      <>
        <div className='content-wrapper1'>
          <div className='row'></div>
          <div className='modal fade' id='modal2'>
            <div
              className='modal-dialog dataGridModal'
              style={
                this.state.message.head === 'Daily Count' ||
                this.state.message.head === 'Weekly Count' ||
                this.state.message.head === 'SOD Count' ||
                this.state.message.head === 'Flows Count' ||
                this.state.message.head === 'BSU Count' ||
                this.state.message.head === 'Additional Count' ||
                this.state.message.head === 'Total'
                  ? { width: '75%' }
                  : { width: 'fitContent' }
              }
            >
              <div className='modal-content'>
                <div
                  className='modal-header'
                  style={{ background: 'rgb(60, 141, 188)', color: '#fff' }}
                >
                  <button
                    type='button'
                    className='close'
                    data-dismiss='modal'
                    aria-label='Close'
                  >
                    <span aria-hidden='true'>×</span>
                  </button>

                  <h4 className='modal-title'>
                    {this.state.message.storeName} - {this.state.message.type} -{' '}
                    {this.state.message.head}
                    <IconButton
                      aria-label='close'
                      onClick={this.state.onClose}
                      data-dismiss='modal'
                      style={{ float: 'right' }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </h4>
                </div>
                {this.props.pageLoad ? (
                  <Spinner />
                ) : (
                  <div className='modal-body'>
                    <table className='table table-bordered table-striped dataGrid'>
                      <thead
                        style={{
                          background: 'rgb(60, 141, 188)',
                          color: '#fff',
                        }}
                      >
                        <tr>
                          {this.props.headers.map((val) => (
                            <th key={val} style={{ textAlign: 'center' }}>
                              {val}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {!this.props.dataForSafetyRegister &&
                        this.state.message.popUpData.length > 0
                          ? this.state.message.popUpData.map((val, index) => {
                              return (
                                <tr key={index}>
                                  {val.map((value) => (
                                    <td style={{ textAlign: 'left' }}>
                                      {value}{' '}
                                    </td>
                                  ))}
                                </tr>
                              );
                            })
                          : ''}
                        {this.props.dataForSafetyRegister &&
                        this.state.message.popUpData.length > 0
                          ? this.state.message.popUpData.map((val, index) => {
                              return (
                                <tr key={index}>
                                  <td>{val[0]}</td>
                                  <td>{val[1]}</td>
                                  <td>{val[2]}</td>
                                  <td>{val[3]}</td>
                                  <td>{val[4]}</td>
                                  <td>{val[5]}</td>
                                  <td
                                    onClick={() => this.fileDownload(val[6])}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {'Click Here'}
                                  </td>
                                </tr>
                              );
                            })
                          : ''}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary deca-btn-orange'
                    onClick={this.state.onClose}
                    data-dismiss='modal'
                  >
                    Ok
                  </button>
                </div>
              </div>

              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        </div>
      </>
    );
  }
}

export default InfoMsgBox;
